import { render, staticRenderFns } from "./ProfileContact.vue?vue&type=template&id=4b488411"
import script from "./ProfileContact.vue?vue&type=script&lang=ts"
export * from "./ProfileContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports